import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReferentialType } from '@core-lib/enums';
import {
	IGetAllNaturesOperationQuery,
	IJoursFermeture,
	IModeleData,
	IParames,
	IReferentials,
	IReferentielNatureOperation,
	IUtilisateurParametre
} from '@core-lib/models';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CarpaService } from './carpa.service';

@Injectable({
	providedIn: 'root'
})
export class ReferentialsService {
	get tenantKey(): string {
		return this.carpaService.currentCarpa.tenantKey;
	}

	constructor(
		private http: HttpClient,
		private carpaService: CarpaService
	) {}

	get(isFromFO: boolean): Observable<IReferentials> {
		if (isFromFO) {
			return this.http.get<IReferentials>(`${environment.apiUrl}/Referentiel/Referentiels/FO`);
		}
		return this.http.get<IReferentials>(`${environment.apiUrl}/Referentiel/Referentiels/BO`);
	}

	getReferentialParameters(): Observable<IParames> {
		// set carpaId
		let carpaId = this.carpaService.currentCarpa?.id;
		if (carpaId) {
			return this.http.get<IParames>(`${environment.apiUrl}/Referentiel/parametres/${carpaId}`);
		}

		return this.http.get<IParames>(`${environment.apiUrl}/Referentiel/parametres`);
	}

	getNaturesOperations(): Observable<IReferentielNatureOperation[]> {
		return this.http.get<IReferentielNatureOperation[]>(`${environment.apiUrl}/Referentiel/natures-operations`);
	}

	loadNaturesOperations(query?: IGetAllNaturesOperationQuery): Observable<IReferentielNatureOperation[]> {
		let params = new HttpParams();
		if (query) {
			params = params.set('propertyName', query.sortBy?.propertyName).set('direction', query.sortBy?.direction.toString());
		}
		return this.http
			.get(`${environment.apiUrl}/t/${this.tenantKey}/natureoperation`, { params: params })
			.pipe(map((i: any) => i?.items));
	}

	getUtilisateursParametres(): Observable<IUtilisateurParametre[]> {
		return this.http.get<IUtilisateurParametre[]>(`${environment.apiUrl}/Referentiel/utilisateurs-parametres`);
	}

	getModelesData(): Observable<IModeleData[]> {
		return this.http.get<IModeleData[]>(`${environment.apiUrl}/modeleDocument/data`);
	}

	/**
	 * loadJoursFermeture
	 * @returns an observable of list of dates
	 */
	loadJoursFermeture(): Observable<IJoursFermeture> {
		// For the "SUPER ADMIN", we load national free days, and for "CARPA ADMIN" we load both national and regional free days
		let carpaId = this.carpaService.currentCarpa?.id;
		if (carpaId) {
			// ADMIN CARPA
			return this.http.get<IJoursFermeture>(`${environment.apiUrl}/t/${this.tenantKey}/referentiel?type=JoursFermeture`);
		}
		// else: SUPER ADMIN
		let type: ReferentialType[] = [ReferentialType.joursFermeture];
		return this.http.get<IJoursFermeture>(`${environment.apiUrl}/referentiel?type=${type}`);
	}

	getAvocatsCC(): Observable<string[]> {
		const carpaId = this.carpaService.currentCarpa?.id;
		return this.http.get<string[]>(`${environment.apiUrl}/parameters/Parameters/MailAvocatsCC/${carpaId}`);
	}
}
